import { get } from 'lodash';

const getPostSubscription = (state, postId) => state.postSubscription[postId];

export const getIsPostSubscribed = (state, postId) =>
  get(getPostSubscription(state, postId), 'isSubscribed', false);
